module.exports = __webpack_public_path__ + "static/media/About-Healthcare.1b0ea1f8.png";